var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgYogaLegGrabStretch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.59863 4.5C4.59863 4.95963 4.68916 5.41475 4.86505 5.83939C5.04095 6.26403 5.29875 6.64987 5.62376 6.97487C5.94876 7.29988 6.3346 7.55769 6.75924 7.73358C7.18388 7.90947 7.63901 8 8.09863 8C8.55826 8 9.01339 7.90947 9.43802 7.73358C9.86266 7.55769 10.2485 7.29988 10.5735 6.97487C10.8985 6.64987 11.1563 6.26403 11.3322 5.83939C11.5081 5.41475 11.5986 4.95963 11.5986 4.5C11.5986 4.04037 11.5081 3.58525 11.3322 3.16061C11.1563 2.73597 10.8985 2.35013 10.5735 2.02513C10.2485 1.70012 9.86266 1.44231 9.43802 1.26642C9.01339 1.09053 8.55826 1 8.09863 1C7.63901 1 7.18388 1.09053 6.75924 1.26642C6.3346 1.44231 5.94876 1.70012 5.62376 2.02513C5.29875 2.35013 5.04095 2.73597 4.86505 3.16061C4.68916 3.58525 4.59863 4.04037 4.59863 4.5V4.5Z",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.8293 11.9707L26.3333 16H21.4266L16.9333 11.5L20.4266 8H24.5986C25.1291 8 25.6378 7.78929 26.0129 7.41421C26.3879 7.03914 26.5986 6.53043 26.5986 6C26.5986 5.46957 26.3879 4.96086 26.0129 4.58579C25.6378 4.21071 25.1291 4 24.5986 4H20.4266C19.3665 4.00328 18.3503 4.42439 17.5986 5.172L9.77064 13H3.59998C3.06954 13 2.56083 13.2107 2.18576 13.5858C1.81069 13.9609 1.59998 14.4696 1.59998 15C1.59998 15.5304 1.81069 16.0391 2.18576 16.4142C2.56083 16.7893 3.06954 17 3.59998 17H9.77064C10.8308 16.9964 11.8468 16.5754 12.5986 15.828L14.0986 14.328L18.5986 18.828V29C18.5986 29.5304 18.8094 30.0391 19.1844 30.4142C19.5595 30.7893 20.0682 31 20.5986 31C21.1291 31 21.6378 30.7893 22.0129 30.4142C22.3879 30.0391 22.5986 29.5304 22.5986 29V20H26.332C26.899 19.9998 27.4596 19.8791 27.9764 19.6458C28.4933 19.4125 28.9546 19.072 29.3299 18.6468C29.7051 18.2217 29.9857 17.7216 30.1529 17.1797C30.3202 16.6379 30.3703 16.0667 30.3 15.504L29.5813 9.752",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.5986 18.828L21.4266 16",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYogaLegGrabStretch);
export default __webpack_public_path__ + "static/media/YogaLegGrabStretch.1258f34ddf2ef8430596c5fd0f7d76aa.svg";
export { ForwardRef as ReactComponent };